import React from 'react'
import BaseIcon from 'react-icon-base'

const DK = props => (
  <BaseIcon width="21" height="15" viewBox="0 0 21 15" {...props}>
    <title>DK</title>
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C60C30"
        d="M19.5,15H1.5C0.7,15,0,14.3,0,13.5V1.5C0,0.7,0.7,0,1.5,0h17.9C20.3,0,21,0.7,21,1.5v11.9
		C21,14.3,20.3,15,19.5,15z"
      />
      <polygon fill="#FEFEFE" points="21,6.5 9,6.5 9,0 6.9,0 6.9,6.5 0,6.5 0,8.5 6.9,8.5 6.9,15 9,15 9,8.5 21,8.5 	" />
      <g>
        <path
          id="c"
          fill="none"
          stroke="#2F343A"
          strokeOpacity="0.157"
          d="M1.5,0.5h18c0.6,0,1,0.4,1,1v12c0,0.6-0.4,1-1,1h-18c-0.6,0-1-0.4-1-1v-12C0.5,0.9,0.9,0.5,1.5,0.5z"
        />
      </g>
    </g>
  </BaseIcon>
)

export default DK
